import { COOKIE_POLICY_ROUTE } from '@constants/routes';
import { useCookieConsent } from '@hooks/policy/useCookieConsent';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation();

  const { isVisible, handleConsent } = useCookieConsent();

  if (!isVisible) return <></>;

  return (
    <div className='z-[999999] fixed bottom-0 w-full bg-gray-600 text-light-base px-6 py-4 flex flex-row items-center justify-between shadow-lg'>
      <div className='mr-2 text-xs'>
        {t('cookieBanner.message')}{' '}
        <Link
          to={COOKIE_POLICY_ROUTE}
          className='underline hover:text-primary-light'>
          {t('cookieBanner.policyLinkText')}
        </Link>
      </div>
      <div className='flex space-x-1 align-center'>
        <button
          type='button'
          onClick={() => handleConsent()}
          className='text-light-base hover:text-gray-200 text-xl font-bold'
          aria-label='Close'>
          &times;
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
